import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
  isAndroid,
  isIOS,
  isIOS13,
  isIPad13,
  isIPhone13,
} from 'react-device-detect';

import { preRoutingActions as actions } from '.';
import { message } from 'antd';
import { sagaRequestTemplate } from 'utils/tools/slice-actions';
import { UTILITY_MODULE } from 'config/api-variables';

export function* loadInstallData({ payload }) {
  try {
    const [relatedApps, downloadLink] = yield all([
      navigator.getInstalledRelatedApps(),
      fetch(process.env.PUBLIC_URL + '/manifest.json')
        .then(res => res.json())
        .then(data => {
          if (isAndroid) {
            return data['related_applications'][0]?.url;
          } else if (isIOS || isIPhone13 || isIOS13 || isIPad13) {
            return data['related_applications'][1]?.url;
          }
        }),
    ]);
    yield put(actions.loadInstallDataSuccess({ relatedApps, downloadLink }));
  } catch (err) {
    if (err.response?.status === 404) {
      message.error(err);
    }
    yield put(actions.loadInstallDataFail());
  }
}

function* fetchPolicyData({ payload }) {
  const { policyFor, ...restPayload } = payload;

  yield call(
    sagaRequestTemplate,
    UTILITY_MODULE + '/app/version/settings',
    restPayload,
    actions,
    'fetchLatestVersionSuccess',
    'fetchActionError',
    `Unable to fetch latest app version`,
    [false],
  );
}

/**
 * Root saga manages watcher lifecycle
 */
export function* preRoutingSaga() {
  yield takeLatest(actions.loadInstallDataStart.type, loadInstallData);

  yield takeLatest(actions.fetchLatestVersionStart.type, fetchPolicyData);
}
